import clsx from 'clsx'
import { COLLECTIONS, type CollectionKey } from '../api/client'

export type TabKey = CollectionKey | 'gallery' | 'replies'

const ORDER: TabKey[] = [
  'posts',
  'replies',
  'reposts',
  'likes',
  'follows',
  'blocks',
  'lists',
  'packs',
  'feeds',
  'gallery',
]

const TITLES: Record<TabKey, string> = {
  posts: 'top-level posts (no replies)',
  replies: 'replies only',
  reposts: COLLECTIONS.reposts,
  likes: COLLECTIONS.likes,
  follows: COLLECTIONS.follows,
  blocks: COLLECTIONS.blocks,
  lists: 'mod / curate / reference lists this user owns',
  packs: 'starter packs this user has published',
  feeds: 'custom feed generators this user has published',
  gallery: 'media from posts + likes + reposts',
}

export function CollectionTabs({
  value,
  onChange,
  counts,
}: {
  value: TabKey
  onChange: (k: TabKey) => void
  counts?: Partial<Record<CollectionKey, number>>
}) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto px-3 pb-2 sm:px-4">
      {ORDER.map((k) => {
        const active = k === value
        const count = k === 'gallery' || k === 'replies' ? undefined : counts?.[k as CollectionKey]
        return (
          <button
            key={k}
            type="button"
            onClick={() => onChange(k)}
            className={clsx(
              'flex flex-shrink-0 items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition',
              active
                ? 'border-[color:var(--accent-strong)] bg-white/10 text-white'
                : 'border-white/10 bg-white/5 text-ink-200 hover:bg-white/10',
            )}
            title={TITLES[k]}
          >
            {k}
            {typeof count === 'number' ? (
              <span className="rounded-full bg-white/10 px-1.5 py-0.5 text-[10px] text-ink-200">
                {count}
              </span>
            ) : null}
          </button>
        )
      })}
    </div>
  )
}
